module.exports = __webpack_public_path__ + "img/Companies.5724df34.svg";